export var defaultProps = {
  children: null,
  isLoading: false,
  onButtonClose: null,
  title: null,
  withCloseButton: false
};